/**
 * @generated SignedSource<<e578fbf621a823b68b52ecdbe6eac3f6>>
 * @relayHash 5ce70e314776017e1baed1e63f025fc8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 75066727100dc349a05e2791bcfba75b789cdffa6b2ea5c586da67bdc4a6a037

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssetsVerticalPermissionCheckInput = {
  dontRequirePrincipalInSite?: boolean | null;
  permissionId: string;
  resourceId: string;
};
export type useJiraAppChromeQuery$variables = {
  appSwitcherProductAri: string;
  atlassianAccountId: string;
  cloudId: string;
  collabContextRoutingAri?: string | null;
  entityAriApps?: string | null;
  entityAriFilters?: string | null;
  entityAriPlans: string;
  entityAriRoadmaps?: string | null;
  entityAriUserSideNavSettings: string;
  fetchGlobalShortcutsAvailableProducts: boolean;
  fetchOldEntityRecord: boolean;
  invitedAppShortcutsProduct: string;
  isAnonymous: boolean;
  isAppsExpanded?: boolean | null;
  isFiltersExpanded?: boolean | null;
  isItamEnabled: boolean;
  isOperationsExpanded?: boolean | null;
  isPlansExpanded?: boolean | null;
  isProjectsExpanded?: boolean | null;
  issueKey: string;
  itamStaticChecks: ReadonlyArray<AssetsVerticalPermissionCheckInput>;
  navPlatMenuDataEntityAri: string;
  navPlatSidebarDataEntityAri: string;
  ownerAri?: string | null;
  projectIdOrKey: string;
  projectKey: string;
  shouldCheckProjectType: boolean;
  shouldCheckProjectTypeForIssue: boolean;
  shouldFetchCSMLiveChatAgent: boolean;
  shouldFetchInvitedAppShortcuts: boolean;
  shouldFetchItamStaticChecks: boolean;
  shouldFetchItamVerticalInstantiations: boolean;
  shouldFetchKeepJsmShortcut: boolean;
  shouldFetchProjectFavicon: boolean;
  shouldFetchProjectType: boolean;
  shouldFetchProjectTypeForSettingsAndEA: boolean;
  shouldFetchSetupTasks?: boolean | null;
  skipAppSwitcherUnitProfile: boolean;
  skipEditionAwarenessFragment: boolean;
  skipHelpButtonRelayRead: boolean;
  skipNavPlatSidebarData: boolean;
};
export type useJiraAppChromeQuery$data = {
  readonly appSwitcherProject?: {
    readonly " $fragmentSpreads": FragmentRefs<"JiraAppSwitcherSlot_query">;
  } | null;
  readonly gsnContent?: {
    readonly " $fragmentSpreads": FragmentRefs<"GSNForContentSidebarEntryPoint">;
  } | null;
  readonly projectFavicon?: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectFaviconService_query">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"AppChrome" | "TopNavigation_slotsQuery">;
};
export type useJiraAppChromeQuery = {
  response: useJiraAppChromeQuery$data;
  variables: useJiraAppChromeQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSentryErrorMissingFavouriteFiltersRelayProvidertsx": isSentryErrorMissingFavouriteFiltersEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNav4SidebarEmptyOnDbErrorRelayProvidertsx": isNav4SidebarEmptyOnDbErrorEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx": isJpdRoadmapsRecentsEnabled_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNav4SidebarEmptyOnDbErrorRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSentryErrorMissingFavouriteFiltersRelayProvidertsx: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx: {
    readonly get: () => boolean;
  };
});

import isNav4SidebarEmptyOnDbErrorEnabled_provider from '@jira/platform__graphql-relay-provider/src/Nav4SidebarEmptyOnDbErrorRelayProvider';
import isSentryErrorMissingFavouriteFiltersEnabled_provider from '@jira/platform__graphql-relay-provider/src/SentryErrorMissingFavouriteFiltersRelayProvider';
import isSubspaceEnabled_provider from '@jira/platform__graphql-relay-provider/src/atlas-project-native-integration-m2.relayprovider';
import isJpdRoadmapsRecentsEnabled_provider from '@jira/platform__graphql-relay-provider/src/isJpdRoadmapsRecentsEnabled';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appSwitcherProductAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianAccountId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "collabContextRoutingAri"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriApps"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriFilters"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriPlans"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriRoadmaps"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAriUserSideNavSettings"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchGlobalShortcutsAvailableProducts"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchOldEntityRecord"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "invitedAppShortcutsProduct"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isAppsExpanded"
},
v14 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isFiltersExpanded"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isItamEnabled"
},
v16 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isOperationsExpanded"
},
v17 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isPlansExpanded"
},
v18 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isProjectsExpanded"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itamStaticChecks"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "navPlatMenuDataEntityAri"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "navPlatSidebarDataEntityAri"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ownerAri"
},
v24 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdOrKey"
},
v25 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v26 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckProjectType"
},
v27 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckProjectTypeForIssue"
},
v28 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchCSMLiveChatAgent"
},
v29 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchInvitedAppShortcuts"
},
v30 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchItamStaticChecks"
},
v31 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchItamVerticalInstantiations"
},
v32 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchKeepJsmShortcut"
},
v33 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectFavicon"
},
v34 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectType"
},
v35 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldFetchProjectTypeForSettingsAndEA"
},
v36 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldFetchSetupTasks"
},
v37 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipAppSwitcherUnitProfile"
},
v38 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipEditionAwarenessFragment"
},
v39 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipHelpButtonRelayRead"
},
v40 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipNavPlatSidebarData"
},
v41 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v42 = {
  "kind": "ScalarField",
  "name": "name"
},
v43 = {
  "kind": "ScalarField",
  "name": "id"
},
v44 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v45 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v46 = [
  (v45/*: any*/),
  (v43/*: any*/)
],
v47 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v48 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "navPlatSidebarDataEntityAri"
  },
  (v47/*: any*/)
],
v49 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v50 = [
  (v49/*: any*/)
],
v51 = [
  {
    "concreteType": "SettingsDisplayProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "key"
      },
      {
        "kind": "ScalarField",
        "name": "value"
      }
    ]
  }
],
v52 = {
  "args": (v50/*: any*/),
  "concreteType": "SettingsDisplayPropertyConnection",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v51/*: any*/),
  "storageKey": "properties(first:100)"
},
v53 = [
  {
    "concreteType": "SettingsMenuItem",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "menuId"
      },
      {
        "kind": "ScalarField",
        "name": "visible"
      }
    ]
  }
],
v54 = {
  "args": (v50/*: any*/),
  "concreteType": "SettingsMenuItemConnection",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": (v53/*: any*/),
  "storageKey": "sidebar(first:100)"
},
v55 = [
  (v54/*: any*/),
  (v52/*: any*/),
  (v43/*: any*/)
],
v56 = {
  "alias": "navPlatL1MenuData",
  "args": [
    {
      "kind": "Variable",
      "name": "entityAri",
      "variableName": "navPlatMenuDataEntityAri"
    },
    (v47/*: any*/)
  ],
  "concreteType": "SettingsNavigationCustomisation",
  "kind": "LinkedField",
  "name": "settings_navigationCustomisation",
  "plural": false,
  "selections": (v55/*: any*/)
},
v57 = {
  "concreteType": "SettingsMenuItemConnection",
  "kind": "LinkedField",
  "name": "sidebar",
  "plural": false,
  "selections": (v53/*: any*/)
},
v58 = {
  "alias": "userSideNavSettings",
  "args": [
    {
      "kind": "Variable",
      "name": "entityAri",
      "variableName": "entityAriUserSideNavSettings"
    },
    (v47/*: any*/)
  ],
  "concreteType": "SettingsNavigationCustomisation",
  "kind": "LinkedField",
  "name": "settings_navigationCustomisation",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    {
      "concreteType": "SettingsDisplayPropertyConnection",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v51/*: any*/)
    },
    (v43/*: any*/)
  ]
},
v59 = [
  (v44/*: any*/)
],
v60 = {
  "kind": "ScalarField",
  "name": "productType"
},
v61 = {
  "kind": "ScalarField",
  "name": "url"
},
v62 = {
  "kind": "ScalarField",
  "name": "message"
},
v63 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v64 = {
  "kind": "ScalarField",
  "name": "label"
},
v65 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v66 = {
  "order": "DESC"
},
v67 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v68 = {
  "kind": "ScalarField",
  "name": "title"
},
v69 = {
  "kind": "ScalarField",
  "name": "isFavourite"
},
v70 = {
  "concreteType": "JiraFavouriteValue",
  "kind": "LinkedField",
  "name": "favouriteValue",
  "plural": false,
  "selections": [
    (v69/*: any*/),
    (v43/*: any*/)
  ]
},
v71 = {
  "kind": "InlineFragment",
  "selections": [
    (v43/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v72 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v41/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v43/*: any*/),
          {
            "kind": "ScalarField",
            "name": "collectionId"
          },
          (v68/*: any*/),
          {
            "kind": "ScalarField",
            "name": "emoji"
          },
          (v70/*: any*/)
        ],
        "type": "JiraProductDiscoveryCollection"
      },
      (v71/*: any*/)
    ]
  }
],
v73 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v74 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v75 = [
  (v44/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectIdOrKey"
  }
],
v76 = [
  {
    "args": (v75/*: any*/),
    "concreteType": "JiraProject",
    "kind": "LinkedField",
    "name": "jira_projectByIdOrKey",
    "plural": false,
    "selections": (v46/*: any*/)
  }
],
v77 = {
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v41/*: any*/),
    {
      "kind": "ScalarField",
      "name": "statusCode"
    },
    {
      "kind": "ScalarField",
      "name": "errorType"
    }
  ]
},
v78 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "identifier"
    },
    (v62/*: any*/),
    (v77/*: any*/)
  ],
  "type": "QueryError"
},
v79 = [
  (v57/*: any*/),
  (v43/*: any*/)
],
v80 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v41/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        (v43/*: any*/)
      ]
    }
  ],
  "type": "JiraCustomFilter"
},
v82 = [
  {
    "concreteType": "QueryError",
    "kind": "LinkedField",
    "name": "errors",
    "plural": true,
    "selections": [
      (v62/*: any*/),
      (v77/*: any*/)
    ]
  }
],
v83 = [
  (v43/*: any*/),
  (v42/*: any*/),
  {
    "kind": "ScalarField",
    "name": "alertSearchQuery"
  }
],
v84 = [
  (v61/*: any*/)
],
v85 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v41/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v43/*: any*/),
          {
            "kind": "ScalarField",
            "name": "planId"
          },
          (v68/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isReadOnly"
          },
          {
            "kind": "ScalarField",
            "name": "planStatus"
          },
          (v70/*: any*/),
          {
            "concreteType": "JiraScenario",
            "kind": "LinkedField",
            "name": "scenario",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "scenarioId"
              },
              (v43/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "defaultNavigationItem",
            "plural": false,
            "selections": [
              (v41/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v84/*: any*/),
                "type": "JiraSoftwareBuiltInNavigationItem"
              },
              (v71/*: any*/)
            ]
          }
        ],
        "type": "JiraPlan"
      },
      (v71/*: any*/)
    ]
  }
],
v86 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v87 = {
  "kind": "ScalarField",
  "name": "status"
},
v88 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "large"
    }
  ]
},
v89 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v90 = {
  "kind": "LinkedField",
  "name": "defaultNavigationItem",
  "plural": false,
  "selections": [
    (v41/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v84/*: any*/),
      "type": "JiraNavigationItem",
      "abstractKey": "__isJiraNavigationItem"
    },
    (v71/*: any*/)
  ]
},
v91 = {
  "args": [
    {
      "kind": "Literal",
      "name": "type",
      "value": "EDIT_PROJECT_CONFIG"
    }
  ],
  "concreteType": "JiraProjectAction",
  "kind": "LinkedField",
  "name": "action",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canPerform"
    }
  ],
  "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
},
v92 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v93 = {
  "kind": "ScalarField",
  "name": "softwareBoardCount"
},
v94 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v95 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": "subspaceCount",
          "kind": "ScalarField",
          "name": "subspaceCount_cse"
        }
      ]
    }
  ]
},
v96 = [
  (v43/*: any*/),
  (v86/*: any*/),
  (v87/*: any*/),
  (v45/*: any*/),
  (v88/*: any*/),
  (v42/*: any*/),
  (v89/*: any*/),
  (v69/*: any*/),
  (v90/*: any*/),
  (v91/*: any*/),
  (v92/*: any*/),
  (v93/*: any*/),
  (v94/*: any*/),
  (v95/*: any*/)
],
v97 = {
  "concreteType": "JiraProjectEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v96/*: any*/)
    }
  ]
},
v98 = {
  "condition": "shouldFetchProjectTypeForSettingsAndEA",
  "kind": "Condition",
  "passingValue": true,
  "selections": (v76/*: any*/)
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useJiraAppChromeQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "AppChrome"
      },
      {
        "kind": "FragmentSpread",
        "name": "TopNavigation_slotsQuery"
      },
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "GSNForContentSidebarEntryPoint"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "gsnContent"
          }
        ]
      },
      {
        "condition": "shouldFetchProjectFavicon",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ProjectFaviconService_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "projectFavicon"
          }
        ]
      },
      {
        "condition": "shouldFetchProjectTypeForSettingsAndEA",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "JiraAppSwitcherSlot_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "appSwitcherProject"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v29/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v34/*: any*/),
      (v35/*: any*/),
      (v36/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSentryErrorMissingFavouriteFiltersRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNav4SidebarEmptyOnDbErrorRelayProvidertsx"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx"
      }
    ],
    "kind": "Operation",
    "name": "useJiraAppChromeQuery",
    "selections": [
      {
        "concreteType": "InfluentsNotificationQuery",
        "kind": "LinkedField",
        "name": "notifications",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "collabContextRoutingAri",
                "variableName": "collabContextRoutingAri"
              }
            ],
            "kind": "ScalarField",
            "name": "unseenNotificationCount"
          }
        ]
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v41/*: any*/),
              (v42/*: any*/),
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  }
                ],
                "type": "AtlassianAccountUser"
              },
              (v43/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "shouldCheckProjectTypeForIssue",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v44/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "issueKey"
                  }
                ],
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectField",
                    "kind": "LinkedField",
                    "name": "projectField",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": (v46/*: any*/)
                      },
                      (v43/*: any*/)
                    ]
                  },
                  (v43/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "shouldCheckProjectType",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v44/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "projectKey"
                  }
                ],
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": (v46/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "skipNavPlatSidebarData",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "navPlatSidebarData",
            "args": (v48/*: any*/),
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
              (v52/*: any*/),
              (v43/*: any*/),
              (v54/*: any*/)
            ]
          },
          (v56/*: any*/)
        ]
      },
      {
        "condition": "skipAppSwitcherUnitProfile",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "productAri",
                "variableName": "appSwitcherProductAri"
              }
            ],
            "kind": "LinkedField",
            "name": "appSwitcher_unitProfile",
            "plural": false,
            "selections": [
              (v41/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "unitName"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "unitIconUrl"
                  }
                ],
                "type": "AppSwitcherUnitProfile"
              }
            ]
          }
        ]
      },
      {
        "condition": "fetchOldEntityRecord",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v58/*: any*/)
        ]
      },
      {
        "condition": "fetchGlobalShortcutsAvailableProducts",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v59/*: any*/),
            "kind": "LinkedField",
            "name": "appSwitcher_availableProductsBySite",
            "plural": false,
            "selections": [
              (v41/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": true,
                    "selections": [
                      (v41/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v60/*: any*/),
                          (v61/*: any*/)
                        ],
                        "type": "AppSwitcherSingleUrlProduct"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v60/*: any*/),
                          {
                            "concreteType": "AppSwitcherProductSite",
                            "kind": "LinkedField",
                            "name": "sites",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "siteId"
                              },
                              (v61/*: any*/)
                            ]
                          }
                        ],
                        "type": "AppSwitcherSiteScopedProduct"
                      }
                    ]
                  }
                ],
                "type": "AppSwitcherAvailableProductsBySite"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v62/*: any*/)
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      },
      {
        "condition": "isAnonymous",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          (v58/*: any*/),
          (v56/*: any*/),
          {
            "alias": "navPlatSidebarData",
            "args": (v48/*: any*/),
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": (v55/*: any*/)
          },
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "condition": "isAppsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v59/*: any*/),
                    "concreteType": "JiraNavigationItemConnection",
                    "kind": "LinkedField",
                    "name": "globalAppNavigationItems",
                    "plural": false,
                    "selections": [
                      (v63/*: any*/),
                      {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/),
                              (v43/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v64/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "appId"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "envLabel"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "iconUrl"
                                  },
                                  (v65/*: any*/),
                                  {
                                    "concreteType": "JiraAppSection",
                                    "kind": "LinkedField",
                                    "name": "sections",
                                    "plural": true,
                                    "selections": [
                                      (v64/*: any*/),
                                      {
                                        "concreteType": "JiraAppNavigationItemNestedLink",
                                        "kind": "LinkedField",
                                        "name": "links",
                                        "plural": true,
                                        "selections": [
                                          (v64/*: any*/),
                                          (v61/*: any*/),
                                          (v65/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "settingsUrl"
                                  },
                                  (v61/*: any*/)
                                ],
                                "type": "JiraAppNavigationItem"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isFiltersExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "hasIsFiltersExpanded",
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "condition": "isProjectsExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "hasIsProjectsExpanded",
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "alias": "shouldDisplay",
                "args": [
                  (v44/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CREATION_ENTRY"
                  }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
              },
              {
                "alias": "roadmapFavourites",
                "args": [
                  (v44/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "sort": (v66/*: any*/),
                      "type": "JPD_COLLECTION"
                    }
                  },
                  (v67/*: any*/)
                ],
                "concreteType": "JiraFavouriteConnection",
                "kind": "LinkedField",
                "name": "favourites",
                "plural": false,
                "selections": [
                  (v63/*: any*/),
                  {
                    "concreteType": "JiraFavouriteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v72/*: any*/)
                  },
                  (v73/*: any*/)
                ]
              },
              {
                "alias": "roadmapRecents",
                "args": [
                  (v44/*: any*/),
                  (v74/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "JPD_COLLECTION"
                    ]
                  }
                ],
                "concreteType": "JiraSearchableEntityConnection",
                "kind": "LinkedField",
                "name": "recentItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSearchableEntityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v72/*: any*/)
                  },
                  (v73/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "condition": "isPlansExpanded",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "hasIsPlansExpanded",
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "args": (v59/*: any*/),
                "concreteType": "JiraAdvancedRoadmapsNavigation",
                "kind": "LinkedField",
                "name": "advancedRoadmapsNavigation",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasEditPermissions"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasCreateSamplePlanPermissions"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasGlobalPlansAdminPermissions"
                  }
                ]
              }
            ]
          },
          {
            "condition": "shouldFetchProjectType",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v76/*: any*/)
          },
          {
            "condition": "shouldFetchCSMLiveChatAgent",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "atlassianAccountId"
                  },
                  (v44/*: any*/)
                ],
                "kind": "LinkedField",
                "name": "csm_liveChatAgent",
                "plural": false,
                "selections": [
                  (v41/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v43/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "liveChatActivity"
                      },
                      {
                        "concreteType": "CustomerServiceSpaceLiveChatActivitiesConnection",
                        "kind": "LinkedField",
                        "name": "liveChatActivitiesBySpace",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "CustomerServiceSpaceLiveChatActivityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v41/*: any*/),
                              {
                                "concreteType": "CustomerServiceSpaceLiveChatActivity",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "activityStatus"
                                  },
                                  (v43/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "CustomerServiceLiveChatAgent"
                  },
                  (v78/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "shouldFetchSetupTasks",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "args": (v59/*: any*/),
                    "concreteType": "JiraUserPreferences",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraNavigationSetupTask",
                        "kind": "LinkedField",
                        "name": "navigationSetupTasks",
                        "plural": true,
                        "selections": [
                          (v41/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "taskId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDismissed"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isAppsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "appsOrder",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriApps"
                  },
                  (v47/*: any*/)
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": (v79/*: any*/)
              }
            ]
          },
          {
            "condition": "isFiltersExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "alias": "favouriteFilters",
                    "args": [
                      (v44/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "sort": (v66/*: any*/),
                          "type": "FILTER"
                        }
                      },
                      (v67/*: any*/)
                    ],
                    "concreteType": "JiraFavouriteConnection",
                    "kind": "LinkedField",
                    "name": "favourites",
                    "plural": false,
                    "selections": [
                      (v63/*: any*/),
                      {
                        "concreteType": "JiraFavouriteEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v43/*: any*/),
                                  (v80/*: any*/),
                                  (v42/*: any*/),
                                  (v69/*: any*/),
                                  (v81/*: any*/)
                                ],
                                "type": "JiraFilter",
                                "abstractKey": "__isJiraFilter"
                              },
                              (v71/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSentryErrorMissingFavouriteFiltersRelayProvidertsx",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v82/*: any*/)
                      },
                      (v73/*: any*/)
                    ]
                  },
                  {
                    "alias": "recentFilters",
                    "args": [
                      (v44/*: any*/),
                      (v74/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "types",
                        "value": [
                          "FILTER"
                        ]
                      }
                    ],
                    "concreteType": "JiraSearchableEntityConnection",
                    "kind": "LinkedField",
                    "name": "recentItems",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSearchableEntityEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v41/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v80/*: any*/),
                                  (v43/*: any*/),
                                  (v42/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v69/*: any*/),
                                      (v81/*: any*/)
                                    ],
                                    "type": "JiraFilter",
                                    "abstractKey": "__isJiraFilter"
                                  }
                                ],
                                "type": "JiraCustomFilter"
                              },
                              (v71/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v73/*: any*/)
                    ]
                  },
                  {
                    "args": (v59/*: any*/),
                    "concreteType": "JiraSystemFilterConnection",
                    "kind": "LinkedField",
                    "name": "systemFilters",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSystemFilterEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraSystemFilter",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v43/*: any*/),
                              (v80/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v69/*: any*/),
                                  (v42/*: any*/),
                                  (v41/*: any*/),
                                  (v81/*: any*/)
                                ],
                                "type": "JiraFilter",
                                "abstractKey": "__isJiraFilter"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "filtersOrder",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriFilters"
                  },
                  (v47/*: any*/)
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": (v79/*: any*/)
              }
            ]
          },
          {
            "condition": "isOperationsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "OpsgenieQuery",
                "kind": "LinkedField",
                "name": "opsgenie",
                "plural": false,
                "selections": [
                  {
                    "args": (v59/*: any*/),
                    "concreteType": "OpsgenieSavedSearches",
                    "kind": "LinkedField",
                    "name": "savedSearches",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "OpsgenieSavedSearch",
                        "kind": "LinkedField",
                        "name": "starred",
                        "plural": true,
                        "selections": (v83/*: any*/)
                      },
                      {
                        "concreteType": "OpsgenieSavedSearch",
                        "kind": "LinkedField",
                        "name": "sharedWithMe",
                        "plural": true,
                        "selections": (v83/*: any*/)
                      },
                      {
                        "concreteType": "OpsgenieSavedSearch",
                        "kind": "LinkedField",
                        "name": "createdByMe",
                        "plural": true,
                        "selections": (v83/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isPlansExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "alias": "favouritePlans",
                    "args": [
                      (v44/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "sort": (v66/*: any*/),
                          "type": "PLAN"
                        }
                      },
                      (v67/*: any*/)
                    ],
                    "concreteType": "JiraFavouriteConnection",
                    "kind": "LinkedField",
                    "name": "favourites",
                    "plural": false,
                    "selections": [
                      (v63/*: any*/),
                      {
                        "concreteType": "JiraFavouriteEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v85/*: any*/)
                      },
                      (v73/*: any*/)
                    ]
                  },
                  {
                    "alias": "recentPlans",
                    "args": [
                      (v44/*: any*/),
                      (v74/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "types",
                        "value": [
                          "PLAN"
                        ]
                      }
                    ],
                    "concreteType": "JiraSearchableEntityConnection",
                    "kind": "LinkedField",
                    "name": "recentItems",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraSearchableEntityEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v85/*: any*/)
                      },
                      (v73/*: any*/)
                    ]
                  }
                ]
              },
              {
                "alias": "plansOrder",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriPlans"
                  },
                  (v47/*: any*/)
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": (v79/*: any*/)
              }
            ]
          },
          {
            "condition": "isProjectsExpanded",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "alias": "canCreateProject",
                    "args": [
                      (v44/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_PROJECT"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "canPerform"
                  },
                  {
                    "args": (v59/*: any*/),
                    "concreteType": "JiraWorkManagementLicensing",
                    "kind": "LinkedField",
                    "name": "jwmLicensing",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "currentUserSeatEdition"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v59/*: any*/),
                "concreteType": "JiraProjectsSidebarMenu",
                "kind": "LinkedField",
                "name": "jira_projectsSidebarMenu",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "mostRecent",
                    "plural": false,
                    "selections": (v96/*: any*/)
                  },
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "mostRecentFromHistory",
                    "plural": false,
                    "selections": [
                      (v43/*: any*/),
                      (v86/*: any*/),
                      (v69/*: any*/),
                      (v87/*: any*/),
                      (v45/*: any*/),
                      (v88/*: any*/),
                      (v42/*: any*/),
                      (v89/*: any*/),
                      (v90/*: any*/),
                      (v91/*: any*/),
                      (v92/*: any*/),
                      (v93/*: any*/),
                      (v94/*: any*/),
                      (v95/*: any*/)
                    ]
                  },
                  {
                    "args": [
                      (v67/*: any*/)
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "favourites",
                    "plural": false,
                    "selections": [
                      (v63/*: any*/),
                      (v97/*: any*/),
                      (v73/*: any*/)
                    ],
                    "storageKey": "favourites(first:15)"
                  },
                  {
                    "args": [
                      (v74/*: any*/)
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "recents",
                    "plural": false,
                    "selections": [
                      (v97/*: any*/),
                      (v73/*: any*/)
                    ],
                    "storageKey": "recents(first:20)"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "favouriteLimit"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "recentLimit"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "displayMode"
                  },
                  (v43/*: any*/),
                  {
                    "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNav4SidebarEmptyOnDbErrorRelayProvidertsx",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": (v82/*: any*/)
                  }
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "roadmapsOrder",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAriRoadmaps"
                  },
                  (v47/*: any*/)
                ],
                "concreteType": "SettingsNavigationCustomisation",
                "kind": "LinkedField",
                "name": "settings_navigationCustomisation",
                "plural": false,
                "selections": (v79/*: any*/)
              }
            ]
          },
          {
            "condition": "isItamEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v59/*: any*/),
                "kind": "LinkedField",
                "name": "assetsVertical_tenantContext",
                "plural": false,
                "selections": [
                  (v41/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "AssetsVerticalTenantContext",
                        "kind": "LinkedField",
                        "name": "tenantContext",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "assetsVerticalWorkspaceAri"
                          },
                          {
                            "concreteType": "AssetsVerticalCompliance",
                            "kind": "LinkedField",
                            "name": "compliance",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isHipaaEnabled"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isCustomerManagedKeyEnabled"
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "type": "AssetsVerticalTenantContextSuccess"
                  }
                ]
              }
            ]
          },
          {
            "condition": "shouldFetchItamStaticChecks",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "checks",
                    "variableName": "itamStaticChecks"
                  },
                  (v44/*: any*/)
                ],
                "kind": "LinkedField",
                "name": "assetsVertical_checkPermissions",
                "plural": false,
                "selections": [
                  (v41/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "AssetsVerticalPermissionCheckResult",
                        "kind": "LinkedField",
                        "name": "results",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "resourceId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "permissionId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "permitted"
                          }
                        ]
                      }
                    ],
                    "type": "AssetsVerticalCheckPermissionsSuccess"
                  }
                ]
              }
            ]
          },
          {
            "condition": "shouldFetchItamVerticalInstantiations",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v44/*: any*/),
                  (v49/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "HAM"
                  }
                ],
                "concreteType": "AssetsVerticalVerticalInstantiationConnection",
                "kind": "LinkedField",
                "name": "assetsVertical_verticalInstantiations",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AssetsVerticalVerticalInstantiationEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AssetsVerticalVerticalInstantiation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          },
                          (v87/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "shouldFetchInvitedAppShortcuts",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "GrowthRecQuery",
                "kind": "LinkedField",
                "name": "growthRecommendations",
                "plural": false,
                "selections": [
                  {
                    "args": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "product",
                            "variableName": "invitedAppShortcutsProduct"
                          },
                          {
                            "kind": "Variable",
                            "name": "tenantId",
                            "variableName": "cloudId"
                          },
                          {
                            "kind": "Literal",
                            "name": "useCase",
                            "value": "invitedAppShortcuts"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "context"
                      }
                    ],
                    "kind": "LinkedField",
                    "name": "recommendations",
                    "plural": false,
                    "selections": [
                      (v41/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": true,
                            "selections": [
                              (v41/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "entityId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "reasons"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "score"
                              }
                            ]
                          },
                          {
                            "concreteType": "GrowthRecContextResult",
                            "kind": "LinkedField",
                            "name": "context",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "tenantId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "product"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "useCase"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "sessionId"
                              }
                            ]
                          }
                        ],
                        "type": "GrowthRecRecommendations"
                      },
                      (v78/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "shouldFetchKeepJsmShortcut",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                  {
                    "alias": "keepJsmShortcutProperty",
                    "args": [
                      (v44/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "propertyKey",
                        "value": "jira.sidebar.gas.jsm-shortcut.keep"
                      }
                    ],
                    "concreteType": "JiraEntityPropertyJSON",
                    "kind": "LinkedField",
                    "name": "jsonUserProperty",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "propertyKey"
                      },
                      (v43/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "skipEditionAwarenessFragment",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          (v98/*: any*/)
        ]
      },
      (v98/*: any*/),
      {
        "condition": "skipHelpButtonRelayRead",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": [
                  (v44/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "propertyKey",
                    "value": "help_button_ui_state"
                  }
                ],
                "concreteType": "JiraEntityPropertyJSON",
                "kind": "LinkedField",
                "name": "jsonUserProperty",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "jsonValue"
                  },
                  (v43/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldFetchProjectFavicon",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v75/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "medium"
                  }
                ]
              },
              (v43/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "75066727100dc349a05e2791bcfba75b789cdffa6b2ea5c586da67bdc4a6a037",
    "metadata": {},
    "name": "useJiraAppChromeQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSentryErrorMissingFavouriteFiltersRelayProvidertsx": isSentryErrorMissingFavouriteFiltersEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNav4SidebarEmptyOnDbErrorRelayProvidertsx": isNav4SidebarEmptyOnDbErrorEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcatlasprojectnativeintegrationm2relayprovider": isSubspaceEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabledtsx": isJpdRoadmapsRecentsEnabled_provider
    }
  }
};
})();

(node as any).hash = "252ff98e46606cf596b5b6664ea6f33b";

export default node;
